module.exports = __webpack_public_path__ + "static/media/1_08.eb1939e9.jpg";